module.exports = __webpack_public_path__ + "static/img/pieswr.65dc3f3f.webp";